import { Controller } from "@hotwired/stimulus"

import { getConsumer } from "@shared/lib/action-cable/consumer"

// CONEK-4035 — Subscribes to CallInsightChannel and reloads the AI-draft
// Turbo Frame when the background analysis job finishes.
// Replaces the `?analyzing=1` poll + manual-refresh link.
export default class extends Controller {
  static values = {
    sessionId: String,
    frameUrl: String,
    spaceGroupId: String,
  }

  connect() {
    this.#subscribe()
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  #subscribe() {
    const consumer = getConsumer(this.spaceGroupIdValue || "default")
    this.subscription = consumer.subscriptions.create(
      { channel: "CallInsightChannel" },
      {
        received: (data) => this.#handleMessage(data),
      },
    )
  }

  #handleMessage(data) {
    if (data.action !== "ready") return
    if (data.call_session_id !== this.sessionIdValue) return
    // Defensive cross-tenant guard: the user's stream can carry events for
    // sessions in another tenant. Drop any payload not scoped to this card's
    // space group when both sides know it.
    if (
      this.spaceGroupIdValue &&
      data.space_group_id &&
      data.space_group_id !== this.spaceGroupIdValue
    )
      return

    const frame = document.getElementById(`ai_draft_${this.sessionIdValue}`)
    if (!frame) return

    // Set src to trigger the Turbo Frame to fetch the updated partial.
    frame.src = this.frameUrlValue
  }
}
